import React, { useEffect, useRef, useState } from "react";
import { apiPost } from "../Utils/apiFetch";
import { isEmpty, pick } from "lodash";
import { jwtDecode } from "jwt-decode";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { apiPath } from "../Utils/apiPath";
import faeye from "../fa-eye.svg";
import faeyeslash from "../fa-eye-slash.svg";
import { showAlert } from "../Utils/Constant";
const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const setUserCoins = useContextSelector(
    AuthContext,
    (ctx) => ctx.setUserCoins,
  );
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const [getValidateCode, setValidateCode] = useState("");

  const setUser = useContextSelector(AuthContext, (ctx) => ctx.setUser);
  const canvasRef = useRef(null);
  const {
    register: register,
    handleSubmit: handleSubmit,
    formState: { errors: errors },
    unregister,
    reset: reset,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  const onSubmit = async (body) => {
    // if (parseInt(body.validateCode) === parseInt(getValidateCode)) {
    setLoading(true);
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    body.website = hostname || "SABAEXCH";
    const { status, data } = await apiPost(
      apiPath.loginUser,
      pick(body, ["username", "password", "uniqueId", "website"]),
    );
    if (status === 200) {
      if (data.success) {
        // toast.success(data?.message)
        showAlert("Logged In Successfully");
        localStorage.setItem("token", data.results.token);
        localStorage.setItem("refresh_token", data.results.refresh_token);
        setUserCoins({
          exposure: data.results.exposure,
          totalCoins: data.results.totalCoins,
        });
        setUser(jwtDecode(data.results.token));
        // window.location.reload();
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
    setLoading(false);
    // }
  };
  // const changeCode = () => {
  //   const canvas = canvasRef.current;
  //   const context = canvas.getContext("2d");
  //   context.font = "bold 70px sans-serif";
  //   const code = Math.floor(1000 + Math.random() * 9000);
  //   context.clearRect(0, 0, canvas.width, canvas.height);
  //   context.fillText(code, 10, 50);
  //   setValidateCode(code);
  // };

  // useEffect(() => {
  //   changeCode();
  // }, []);

  useEffect(() => {
    if (!isEmpty(user)) {
      navigate("/");
    }
  }, [user]);
  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = (e) => {
    e.preventDefault();
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  return (
    <>
      {loading && (
        <div apptheme className="over-wrap loading-overlay ng-star-inserted">
          <div
            id="loading"
            className="loading-wrap"
            style={{ display: "block" }}
          >
            <ul className="loading">
              <li className="ng-star-inserted">
                <img
                  src="/assets/images/loading40.gif"
                  className="loaderclass"
                />
              </li>

              <li style={{ padding: "10px" }}>Loading... </li>
              <br />
              <li>
                <span id="progress" />
              </li>
            </ul>
          </div>
        </div>
      )}
      <div className="dynamicBack ng-star-inserted">
        <div className="scene" />
        <div apptheme className="login-wrap">
          <div className="kv">
            <img src="/assets/images/transparent.gif" alt="Logo" />
          </div>
          <Form
            onSubmit={handleSubmit(onSubmit)}
            className="login-panel ng-invalid ng-dirty ng-touched"
          >
            <div className="header black-text">Agent Login</div>
            <Form.Control
              type="text"
              placeholder="Username"
              className="ng-dirty ng-valid ng-touched"
              {...register("username", {
                required: "Please enter Username",
              })}
            />{" "}
            {errors.username && errors?.username?.message && (
              <label className="invalid-feedback text-left">
                {errors.username.message}
              </label>
            )}
            <div className="password-group">
              <Form.Control
                placeholder="Password"
                type={passwordType ? passwordType : "password"}
                className="ng-dirty ng-valid ng-touched"
                {...register("password", {
                  required: "Please enter password",
                })}
              />
              <div
                className="input-group-btn"
                style={{
                  position: "absolute",
                  right: "0",
                  top: "0",
                  bottom: "0px",
                }}
              >
                <span
                  className="btn btn-outline-primary"
                  onClick={togglePassword}
                  style={{
                    backgroundColor: "transparent",
                    backgroundImage: `none`,
                    border: "0",
                    padding: "8px 6px",
                    paddingTop: "3px",
                    height: "72%",
                    fontSize: `3.5vw`,
                  }}
                >
                  {passwordType === "password" ? (
                    <img src={faeyeslash} style={{ width: `20px` }} />
                  ) : (
                    <img src={faeye} style={{ width: `20px` }} />
                  )}
                </span>
              </div>

              {errors.password && errors.password.message && (
                <label className="invalid-feedback text-left">
                  {errors.password.message}
                </label>
              )}
            </div>
            {/* <div className="password-group">
              <Form.Control
                type="text"
                placeholder="Validate Code"
                maxLength="4"
                className={errors.validateCode ? "is-invalid" : ""}
                {...register("validateCode", {
                  required: "Please enter validate code",
                  validate: {
                    validate: (value) =>
                      parseInt(value) === parseInt(getValidateCode) ||
                      "Invalid validate code",
                  },
                })}
              />
              <canvas
                style={{
                  position: "absolute",
                  right: "-12%",
                  top: "20%",
                }}
                className="canvas-img "
                ref={canvasRef}
                onClick={changeCode}
              />
              {errors.validateCode && errors.validateCode.message && (
                <label className="invalid-feedback text-left">
                  {errors.validateCode.message}
                </label>
              )}
            </div> */}
            <button type="submit" className="btn-send">
              {" "}
              Login
              <img
                src="/assets/images/transparent.gif"
                className="icon-login"
              />
            </button>
            <div className="apk-container ng-star-inserted">
              {/* <a
                id="apk"
                href="https://ag.static112233.com/assets/apk/betx365.apk?v=0651651"
                download="betx365.apk"
              > */}
              <img src="/assets/images/android.png" width="auto" />
              {/* </a> */}
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Login;
